const CATEGORIES_BASE_API_ROUTE = '/categories';

export const CATEGORIES_API_ROUTE = {
  index: () => CATEGORIES_BASE_API_ROUTE,
} as const;
